<template>
 <div>
    <v-app id="app">
      <!-- <AppHeader /> -->
      <router-view
        style="min-height: 80vh"
      />
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
// import store from "./store";
import "./assets/styles/fonts.css";
import "./assets/styles/appStyle.css";

export default {
  data() {
    return {
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      check:false,
      sideNav: false,
    };
  },
  beforeMount() {
    if (typeof localStorage.getItem("token") == "string") {
      this.$store.commit("appLoading", true);
      axios({
        method: "GET",
        url: "/user/info",
        headers: {
          "x-auth-token": localStorage.getItem ("token"),
        },
        params:{
          id:localStorage.getItem("id"),
          date: this.billDate,
        }
      })
        .then((response) => {
          // console.log("curr path==",this.$route.path);
          if (response.data.status) {
            this.$store.commit("appLoading", false);
            this.$store.commit("userData", response.data.data);
            this.$store.commit("userType", response.data.data.mainRole.roles);
            this.$store.commit("menu", response.data.menus);

          }
          else
          {
            this.$store.commit("appLoading", false);

          }
        })
        .catch((err) => {
          this.$store.commit("appLoading", false);
          console.log(err);
        });
    }
  },
};
</script>
